import React, { useState } from 'react';
import AccountCampaignMenubar from '../components/account-campaign-menubar';

import { useGetAccountsQuery } from '../endpoints/accounts.endpoints';
import { useGetCompaniesQuery } from 'src/pages/billing/endpoints/billing.endpoints';
import AccountTable from '../components/account-table';

const ManageAccountsTab: React.FC = () => {
  const [searchParams] = useState(() => new URLSearchParams(window.location.search));
  const defaultSearch = searchParams.get('search') || '';

  const [filter, setFilter] = useState<'attention_needed' | 'all'>('attention_needed');
  const [searchQuery, setSearchQuery] = useState(defaultSearch);
  const { data: accounts = [], isLoading, error, refetch } = useGetAccountsQuery({});
  const { data: companies = [] } = useGetCompaniesQuery();

  const handleCompanySelect = (accountId: string, companyId: string) => {
    refetch();
  };

  return (
    <div className="h-full w-full flex flex-col space-y-4 pt-0 min-h-0">
      <div className="flex">
        <AccountCampaignMenubar
          label='Accounts'
          items={accounts}
          className='bg-gray-201 text-black rounded-full'
          selectedFilter={filter}
          filterSelect={setFilter}
          searchQuery={searchQuery}
          searchChange={setSearchQuery}
        />
      </div>

      <div className="flex h-full min-h-0">
        <AccountTable
          accounts={accounts}
          companies={companies}
          onCompanySelect={handleCompanySelect}
          className='h-full'
          filter={filter}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
};

export default ManageAccountsTab;
